import React, { Component } from "react";
import "../css/footer.css";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = { currYear: new Date().getFullYear() };
  }
  render() {
    return (
      <React.Fragment>
        <div className="container-fluid footer_container">
          <div className="text-center">
            &copy;{this.state.currYear}&nbsp; Made with <strong className="footer_heart">❤</strong> by{" "}
            <a href="https://github.com/AshwinkumarPillai/" target="_blank" rel="noreferrer">
              Ashwin
            </a>{" "}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Footer;
